import React, { ReactElement } from 'react';
import { SortSelect } from 'slovlex-idsk-react-components';
import { sortValuesProcesy } from '../../../../constants/SortConstants';

const LegMaterialListSort = (): ReactElement => (
  <SortSelect
    sortList={[
      {
        sort: sortValuesProcesy[0],
        title: 'PK (od najnovších)',
        sortBy: 'desc',
      },
      {
        sort: sortValuesProcesy[0],
        title: 'PK (od najstarších)',
        sortBy: 'asc',
      },
      {
        sort: sortValuesProcesy[1],
        title: 'Začiatok štádia (od najnovších)',
        sortBy: 'desc',
      },
      {
        sort: sortValuesProcesy[1],
        title: 'Začiatok štádia (od najstarších)',
        sortBy: 'asc',
      },
      {
        sort: sortValuesProcesy[2],
        title: 'Typ materiálu (A-Z)',
        sortBy: 'asc',
      },
      {
        sort: sortValuesProcesy[2],
        title: 'Typ materiálu (Z-A)',
        sortBy: 'desc',
      },
      {
        sort: sortValuesProcesy[3],
        title: 'Názov (A-Z)',
        sortBy: 'asc',
      },
      {
        sort: sortValuesProcesy[3],
        title: 'Názov (Z-A)',
        sortBy: 'desc',
      },
    ]}
  />
);

export default LegMaterialListSort;
